                                                                        import { uuid } from 'utils';
import { ALL_BETS, WIN } from 'constants/betHistory';

import ethereumLogo from 'assets/images/partner-logo/03_ethereum_46X250px.svg';
// import getFtnUrl from 'assets/images/partner-banner/get_ftn_arrow_right.svg';

const config = {
  currentYear: 2024,
  dbetApiUrl: 'https://api.decaplay.io',
  betHistory: {
    offsetLimit: 50,
    filterTabs: [ALL_BETS, WIN],
  },
  header: {
    showFlags:false,
    authorization: {
      nativeWalletLink: '/casino/native-wallet',
    },
    languageSwitcher: {
      enabled: true,
    },
  },
  game: {
    fairnessEnabled: false,
  },
  currentCurrency: 'ETH',
  navigation: [
    {
      id: uuid(),
      label: 'games',
      icon: 'games_menu',
      hasChildren: true,
    },
    {
      path: '/casino/help',
      id: uuid(),
      label: 'Help',
      icon: 'help',
      hideForHeader: true,
    },
    {
      path: '/casino/fairness',
      id: uuid(),
      label: 'Fairness',
      icon: 'fairness',
    },
    {
      path: '/casino/native-wallet',
      id: uuid(),
      label: 'Native Wallet',
      icon: 'native_wallet',
    },
  ],
  footer: {
    currenciesBlock: [
      {
        order: 1,
        src: ethereumLogo,
        id: uuid(),
        href: 'https://ethereum.org/en/',
        alt: 'Ethereum',
      },
    ],
    sectionBlock: [
      {
        order: 1,
        label: 'faq',
        id: uuid(),
        src: '/casino/help',
        name: 'Help',
      },
      {
        order: 2,
        label: 'fairness',
        id: uuid(),
        src: '/casino/fairness',
        name: 'Fairness',
      },
      {
        order: 3,
        label: 'native-wallet',
        id: uuid(),
        src: '/casino/native-wallet',
        name: 'Native Wallet',
      },
    ],
    socialsBlock: [
      { id: uuid(), href: "https://x.com/XBettingOffcl", label: "twitter-x" },
      { id: uuid(), href: "https://www.instagram.com/xbettingcom/", label: "instagram" },
    ]
  },
  balance: {
    wallet: {
      tabs: [
        {
          id: uuid(),
          title: 'Native Wallet',
        },
        {
          id: uuid(),
          title: 'Deposit',
        },
        {
          id: uuid(),
          title: 'Withdraw',
        },
        {
          id: uuid(),
          title: 'History',
        },
      ],
    },
    deposit: {
      fixedAmounts: [
        {
          id: uuid(),
          amount: '0.01',
          label: '0.01',
        },
        {
          id: uuid(),
          amount: '0.02',
          label: '0.02',
        },
        {
          id: uuid(),
          amount: '0.05',
          label: '0.05',
        },
        {
          id: uuid(),
          amount: '0.1',
          label: '0.1',
        },
        {
          id: uuid(),
          amount: '1',
          label: 'Max',
        },
      ],
    },
    minWithdrawAmount: 0.0001,
    minDepositAmount: 0.01,
  },
  cms: {
    url: 'https://www.cmsbetconstruct.com',
    baseHost: 'www.dbet.com',
  },
  supportedMetamaskBrowsers: {
    chrome: {
      title: 'Google Chrome',
      target: '_blank',
      rel: 'noreferrer noopener',
      href: 'https://www.google.com/chrome/',
    },
    firefox: {
      title: 'Mozilla Firefox',
      target: '_blank',
      rel: 'noreferrer noopener',
      href: 'https://www.mozilla.org/en-US/firefox/new/',
    },
    brave: {
      title: 'Brave',
      target: '_blank',
      rel: 'noreferrer noopener',
      href: 'https://brave.com/',
    },
  },
  languages: ['en', 'ru','tr'],
  metamaskExtensionUrl: {
    android: 'https://play.google.com/store/apps/details?id=io.metamask',
    firefox: 'https://addons.mozilla.org/en-US/firefox/addon/ether-metamask',
    iOS: 'https://apps.apple.com/us/app/metamask-blockchain-wallet/id1438144202',
    chrome: 'https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn',
  },
  providersURL: {
    0: 'slots.vbet.com',
    1: 'fun.pokgaming.com',
    2: 'pg-stage.rpd.cloud',
  },
  content: {
    title: 'xbetting',
    telegramUrl: 'https://t.me/Xbetting_com',
    bannerButtons: [
      '/partnerSlides/{{lang}}/{{index}}.png',
      '/partnerSlides/{{lang}}/{{index}}.png',
      '/partnerSlides/{{lang}}/{{index}}.png',
      '/partnerSlides/{{lang}}/{{index}}.png',
    ],
    showPageButton: false,
    pageButtonHref: '',
    pageButtonText: {},
    menuSpecificButton: '',
    withHoory: true,
    menuSpecificButtonHref: '',
    logoExtension: 'svg',
    fonts: {
      initial: 'Poppins',
      android: 'Roboto',
      mac: 'Helvetica Neue',
      windows: ['Arial', 'Segoe UI'],
      ubuntu: 'Ubuntu',
    },
  },
  currentSkin: 'erc20',
  skinnings: {
    asian: {
      main: {
        name: 'main',
        logo: 'dark',
        colors: {
          skin: '#F0F0F3',
          primary: '#3DA1FE',
          primaryScInvert: '#ffffff',
          secondary: '#EFCB37',
        },
      },
    },
    classic: {
      main: {
        name: 'main',
        logo: 'light',
        colors: {
          skin: '#140D36',
          primary: '#C24F9D',
          secondary: '#8938F9',
          accent: '#8AD0F1',
          primaryScInvert: '#ffffff',
          secondaryScInvert: '#ffffff',
        },
      },
      light: {
        name: 'light',
        logo: 'dark',
        colors: {
          skin: '#ffffff',
          primary: '#C24F9D',
          secondary: '#8938F9',
          accent: '#4586a4',
          primaryScInvert: '#ffffff',
          secondaryScInvert: '#ffffff',
        },
      },
    },
    erc20: {
      main: {
        name: 'main',
        logo: 'light',
        colors: {
          skin: '#14171A',
          primary: '#1DA1F2',
          walletConnectIcon: '#14171A',
          secondary: '#657786',
          bannerText: '#E1E8ED',
          accent: '#1DA1F2',
          primaryScInvert: '#AAB8C2',
          secondaryScInvert: '#AAB8C2',
        },
      },
    },
  },
};

export default config;
